import React from 'react';

const Navigation = ({
  isMenuOpen,
  onClose,
  isDarkMode = false,
  toggleDarkMode,
  isEasyMode,
  setIsEasyMode,
  setYearSelectionStep
}) => {
  const handleModeToggle = () => {
    setIsEasyMode(!isEasyMode);
    onClose();
  };

  const handleYearSelect = () => {
    setYearSelectionStep(true);
    onClose();
  };

  return (
    <>
      {/* Add menu overlay */}
      <div
        className={`menu-overlay ${isMenuOpen ? 'visible' : ''}`}
        onClick={onClose}
      />
      <nav
        className={`navigation-menu ${isMenuOpen ? 'open' : ''}`}
        role="navigation"
        aria-label="Main menu"
      >
        <div className="menu-content">
          <button
            className="menu-item"
            onClick={handleModeToggle}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '20px' }}>{isEasyMode ? '🎯' : '🔥'}</span>
              <span>{isEasyMode ? 'Switch to Hard Mode' : 'Switch to Easy Mode'}</span>
            </span>
            <span style={{ fontSize: '18px', opacity: 0.6 }}>→</span>
          </button>
          <button
            className="menu-item"
            onClick={handleYearSelect}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '20px' }}>📅</span>
              <span>Choose Year Range</span>
            </span>
            <span style={{ fontSize: '18px', opacity: 0.6 }}>→</span>
          </button>
          <button
            className="menu-item"
            onClick={() => {
              toggleDarkMode();
              onClose();
            }}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '20px' }}>{isDarkMode ? '☀️' : '🌙'}</span>
              <span>{isDarkMode ? 'Light Mode' : 'Dark Mode'}</span>
            </span>
            <span style={{ fontSize: '18px', opacity: 0.6 }}>→</span>
          </button>
          <a
            href="https://crossovergrid.com"
            target="_blank"
            rel="noopener noreferrer"
            className="menu-item"
            onClick={onClose}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              marginTop: '20px',
              paddingTop: '20px',
              borderTop: isDarkMode ? '1px solid rgba(255,255,255,0.2)' : '1px solid rgba(0,0,0,0.1)'
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '20px' }}>🏠</span>
              <span>CrossoverGrid Home</span>
            </span>
            <span style={{ fontSize: '18px', opacity: 0.6 }}>↗</span>
          </a>
        </div>
      </nav>
    </>
  );
};

export default Navigation; 